export default __webpack_public_path__ + "static/MessinaSansWeb-Book-8b0204ecfc225d1e3034f22c602c9a58.woff";